import styled from "@emotion/styled"

const HeroScrollCaseContainerSmall = styled.div`
  width: 80%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: -164px auto 40px;


  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: -64px auto 80px;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    display: none;
  }

  & > * {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
export default HeroScrollCaseContainerSmall
